import { graphql } from "relay-runtime"

export const deMedicalReportUploadMutation = graphql`
  mutation deMedicalReportUploadMutation($input: De_uploadMedicalReportFilesInput!, $addConnections: [ID!]!) {
    uploadMedicalReportFiles: de_uploadMedicalReportFiles(input: $input) {
      uploadMedicalReportFilesOutput {
        ... on SuccessUploadMedicalReportFilesOutput {
          attachments @appendNode(connections: $addConnections, edgeTypeName: "de_ProgressNoteEdge") {
            ...medicalReportAttachmentFragment @relay(mask: false)
          }
        }
        ... on ErrorUploadMedicalReportFilesOutput {
          isSuccess
          error {
            fileName
            message
          }
        }
      }
    }
  }
`
